import { batch } from 'react-redux';
export default function updateSavedSearchItemActionCreator(userDuck, personalization, savedInventoryDuck) {
  return data => async (dispatch, getState) => {
    const {
      updateSavedSearch
    } = typeof getState().toJS === 'function' ? getState().get('user') : getState().user;
    let overwrite = false;

    // Only current warning is to alert user that a saved title exists
    // if there is an existing warning then we have to assume that user has seen the warning and wants to overwrite
    // If not then we leave overwrite as false as they are attempting another name and we need to go through the process again
    const isOverwritable = updateSavedSearch.messages && updateSavedSearch.messages.warning;
    if (isOverwritable) {
      overwrite = true;
    }
    try {
      dispatch({
        type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
        payload: 'loading'
      });
      const actionResponse = await personalization.updateSavedSearchItem({
        ...data,
        overwrite
      });
      if (actionResponse.messages) {
        // display warning/error messages
        dispatch(userDuck.creators.setUpdateSavedSearchState({
          messages: actionResponse.messages
        }));
        dispatch({
          type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
          payload: ''
        });
      } else {
        dispatch(userDuck.creators.setSavedSearchItem({
          ...actionResponse.bookmark
        }));
        dispatch({
          type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
          payload: 'loaded'
        });
        setTimeout(() => {
          batch(() => {
            dispatch(userDuck.creators.hideUpdateSavedSearch());
            dispatch({
              type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
              payload: ''
            });
          });
        }, 500);
      }
      return actionResponse;
    } catch (error) {
      throw Error(error);
    }
  };
}